import React from 'react';
import { Button, Card, Table } from 'react-bootstrap';
import styles from './OrdersModal.module.scss';

import ModalWrapper from '../ModalWrapper';

type Props = {
  isShow: boolean;
  closeModal: () => void;
  className?: string;
  closeHandler?: () => void;
  order?: any;
};

const OrdersModal: React.FC<Props> = ({ isShow, closeModal, closeHandler, order }) => (
  <ModalWrapper
    dialogClassName={styles.modal}
    className={styles.wrapper}
    show={isShow}
    onHide={closeHandler ? () => closeHandler() : closeModal}
  >
    {/* eslint-disable-next-line no-prototype-builtins */}
    {order?.hasOwnProperty('body') ? (
      <Card.Body className="pt-0 pb-2">
        {order?.body !== null ? (
          <>
            <h6 className="text-center mb-4">Деталі замовлення {order?.body?.orderObject}</h6>
            {order?.body?.orderParts?.map((o: any, index: number) => (
              <>
                <h6 className="text-center mb-4">
                  Поставка {o?.number || '[не створена],'} {o?.warehouseName}
                </h6>
                <Table>
                  {o?.positions.map((pos: any) => (
                    <tbody>
                      <tr key={`order-${index}`}>
                        <td className={styles.td1}>{pos?.ozmNumber}</td>
                        <td className={styles.td2}>{pos?.productName}</td>
                        <td className={styles.td3}>
                          {pos?.length} x {pos?.width} x {pos?.thickness}
                        </td>
                        <td className={styles.td4}>{pos?.netWeight}</td>
                        <td className={styles.td5}>{pos?.prizTeorVesa}</td>
                        <td className={styles.td6}>{pos?.deliveryStatus}</td>
                      </tr>
                    </tbody>
                  ))}
                </Table>
              </>
            ))}
            <div className="d-flex justify-content-around">
              <Button className="mr-4 px-5" onClick={closeModal} variant="outline-secondary">
                OK
              </Button>
            </div>
          </>
        ) : (
          <>
            {order?.errorMessages?.map((val: any) => (
              <h6 className="text-center mb-4">{val}</h6>
            ))}
            <div className="d-flex justify-content-around">
              <Button className="px-5" onClick={closeModal} variant="outline-secondary">
                OK
              </Button>
            </div>
          </>
        )}
      </Card.Body>
    ) : (
      <Card.Body className="pt-0 pb-2">
        <h6 className="text-center mb-4">{order?.data?.Errors[0]?.Message}</h6>
        <div className="d-flex justify-content-around">
          <Button className="px-5" onClick={closeModal} variant="outline-secondary">
            OK
          </Button>
        </div>
      </Card.Body>
    )}
  </ModalWrapper>
);

export default OrdersModal;
